export default {
  FEATURED_VIDEO: 1,
  CHANNEL_COVER: 2,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/main-item-type-values.js